import {createAsyncThunk, createSlice} from '@reduxjs/toolkit';
import ProviderManager from '../../../provider/providerManager';
import { gtag4 } from '../../../utilities/analytics/tracking';
import { buildUrl } from '../../../utilities/StringHelpers/StringHelpers';
import { showAppLoader, hideAppLoader } from '../../Shared/Loader/LoaderSlice';
import { pages } from './pages';

export const createOtp = createAsyncThunk('electricCompanyLeadBlock/createOtp', async (data, thunkAPI) => {
  try {
    thunkAPI.dispatch(showAppLoader());

    const state = thunkAPI.getState().electricCompanyLeadBlock;
    const formDetails = state.formDetails;

    const firstName = formDetails.fullName.split(' ')[0];
    const lastName = formDetails.fullName.split(' ')[1];

    const request = {
      requestType: "create_otp",
      firstName : firstName,
      lastName : lastName,
      idNumber: formDetails.identityNumber,
      phoneNumber: formDetails.phoneNumber,
    }

    const result = await ProviderManager.getProviderData('IECBotCheckSmartMeter', request);

    if(result.Body.state.toLowerCase() == 'initialized'){
      thunkAPI.dispatch(goToPage('otpVerifyCodePage'));
    }

    return result.Body;
  } catch (err) {
    console.log(err);
  } finally {
    thunkAPI.dispatch(hideAppLoader());
  }
});

export const validateOtp = createAsyncThunk('electricCompanyLeadBlock/validateOtp', async (data, thunkAPI) => {
  try {
    thunkAPI.dispatch(showAppLoader());

    const state = thunkAPI.getState().electricCompanyLeadBlock;
    const otpCode = state.otpDetails.verifyCode;
    const sessionId = state.sessionId;

    const request = {
      requestType: "validate_otp",
      sessionId : sessionId,
      otpCode : otpCode
    }

    const result = await ProviderManager.getProviderData('IECBotCheckSmartMeter', request);

    if(result.Body.state.toLowerCase() == 'processing' || result.Body.state.toLowerCase() == 'started'){
      thunkAPI.dispatch(getDetails());
    }
    else{
      setPageResponse(result.Body, thunkAPI);
      thunkAPI.dispatch(hideAppLoader());
    }

    return result.Body;
  } catch (err) {
    thunkAPI.dispatch(serviceMessageType('ERROR'));
    thunkAPI.dispatch(goToPage('serviceMessagePage'));
    thunkAPI.dispatch(createLead());
    thunkAPI.dispatch(hideAppLoader());
  } finally {
  }
});

export const getDetails = createAsyncThunk('electricCompanyLeadBlock/getDetails', async (data, thunkAPI) => {
  try {
    thunkAPI.dispatch(showAppLoader());

    const state = thunkAPI.getState().electricCompanyLeadBlock;
    const sessionId = state.sessionId;

    const request = {
      requestType: "get_details",
      sessionId : sessionId,
    }

    const result = await ProviderManager.getProviderData('IECBotCheckSmartMeter', request);

    thunkAPI.dispatch(setResponse(result.Body));
    setPageResponse(result.Body, thunkAPI);

    return result.Body;
  } catch (err) {
    thunkAPI.dispatch(serviceMessageType('ERROR'));
    thunkAPI.dispatch(goToPage('serviceMessagePage'));
    thunkAPI.dispatch(createLead());
  } finally {
    thunkAPI.dispatch(hideAppLoader());
  }
});

export const createLead = createAsyncThunk('electricCompanyLeadBlock/createLead', async (data, thunkAPI) => {
  try {
    const state = thunkAPI.getState().electricCompanyLeadBlock;

    const campaignCode = state.cmsBlockData.campaignCode;
    const campaignName = state.cmsBlockData.campaignName;
    const productId = state.cmsBlockData.productId;
    const fullName = state.formDetails.fullName;
    const phoneNumber = state.formDetails.phoneNumber;
    const customerIdNumber = state.formDetails.identityNumber;
    const url = encodeURI(window.location.origin + window.location.pathname);
    const isAgreementsCheckBoxActive = false;
    const description = getDescriptionForLead(data);
    const bannerId = '';
    const searchTerm = '';
    const adSource = '';
    const recaptchaToken = '';

    const result = await ProviderManager.getProviderData('createLead', [
      recaptchaToken,
      fullName,
      phoneNumber,
      campaignCode,
      campaignName,
      productId,
      adSource,
      url,
      bannerId,
      searchTerm,
      isAgreementsCheckBoxActive,
      description,
      customerIdNumber
    ]);

    if(result.Body?.isSuccess){
      if(state.response?.state?.toLowerCase() == 'error'){
        thunkAPI.dispatch(reportDWH({ actionType: 'Check Energy Counter', status: 'Ongoing', messageText: 'General Error - Send Lead' }));
      }
      else{
        if(state.response?.serviceMigratable == 'כן'){
          thunkAPI.dispatch(reportDWH({ actionType: 'Check Energy Counter', status: 'Ongoing', messageText: 'Yes Smart counter - Send Lead' }));
        }
        else{
          thunkAPI.dispatch(reportDWH({ actionType: 'Check Energy Counter', status: 'Ongoing', messageText: 'No Smart counter - Send Lead' }));
        }
      }
    }

    return result.Body;
  } catch (err) {
    console.log(err);
  } finally {
  }
});

const initialState = {
  page: 'otpFormPage',
  pagePercent: 0,
  progressBarPoints: [],
  cmsBlockData: {},
  otpDetails: {
    numOfAttempts: 0,
    verifyCode: '',
    valid: '',
    error: '',
  },
  formDetails:{
    fullName: '',
    phoneNumber: '',
    identityNumber: ''
  },
  isSubmit: false,
  sessionId: '',
  response: {},
  serviceMessageType: ''
}


const electricCompanyLeadBlockSlice = createSlice({
  name: 'electricCompanyLeadBlock',
  initialState: initialState,
  reducers: {
    resetBlock: (state) => initialState,
    initBlock: {
      reducer: (state, action) => {
        state.cmsBlockData = action.payload.cmsBlockData;
        state.page = action.payload.page;
        state.progressBarPoints = action.payload.progressBarPoints;
      },
      prepare: (action) => {
        let payload = {};

        const cmsBlockData ={
          campaignCode: action.cmsBlockData.campaignCode?.value,
          campaignName: action.cmsBlockData.campaignName?.value,
          productId: action.cmsBlockData.productId?.value,
          // isDisplayWhatsapp: !!action.cmsBlockData.isDisplayWhatsapp?.value,
          energyPageLink: buildUrl(action.cmsBlockData.energyPageLink?.value),
          companyPrivacyPolicyLink: buildUrl(action.cmsBlockData.companyPrivacyPolicyLink?.value),
        }

        const progressBarPoints = pages.map(function (item) {
          return item['percent'];
        });

        payload.cmsBlockData = cmsBlockData;
        payload.page = 'otpFormPage';
        payload.progressBarPoints = progressBarPoints;
        return { payload: payload };
      },
    },
    reportAnalytics: (state, action) => { },
    reportDWH: (state, action) => { },
    goToPage: (state, action) => {
      state.page = action.payload;

      let page = pages.find((x) => x.page == action.payload);
      if (page && page.percent) {
        state.pagePercent = page.percent;
      }
    },
    setIsSubmit: (state, action) => {
      state.isSubmit = action.payload;
    },
    setFormDetails: (state, action) => {
      state.formDetails.fullName = action.payload.fullName?.trim();
      state.formDetails.phoneNumber = action.payload.phoneNumber;
      state.formDetails.identityNumber = action.payload.identityNumber;
    },
    setOtpCode: (state, action) => {
      state.otpDetails.verifyCode = action.payload;
    },
    setOtpErrorMsg: (state, action) => {
      state.otpDetails.error = action.payload;
    },
    setResponse: (state, action) => {
      state.response = action.payload;
    },
    serviceMessageType:(state, action) => {
      state.serviceMessageType = action.payload;
    }
  },
  extraReducers: {
    [createOtp.fulfilled]: (state, action) => {
      state.sessionId = action.payload.sessionId;
      state.otpDetails.numOfAttempts = ++state.otpDetails.numOfAttempts;
    },
    [validateOtp.fulfilled]: (state, action) => {
      const status = action.payload.state;
      if(status.toLowerCase() == 'session not found' ){
        state.otpDetails.error = 'אנא נסה שנית';
      }
    },
    [getDetails.fulfilled]: (state, action) => {
    },
    [createLead.fulfilled]: (state, action) => {
    },
  },
});

export const {
  resetBlock,
  initBlock,
  resetState,
  reportAnalytics,
  reportDWH,
  goToPage,
  setIsSubmit,
  setFormDetails,
  setOtpCode,
  setOtpErrorMsg,
  setResponse,
  serviceMessageType
} = electricCompanyLeadBlockSlice.actions;

export default electricCompanyLeadBlockSlice.reducer;


function getDescriptionForLead(data){
  let description = "בקשה הגיעה מבוט, ";
  if(data){
    if(data?.currentConsumption){
      description = description + "מספר מונה: " + data.currentConsumption + " , ";
    }
    if(data?.contractId){
      description = description + "מספר " + data.contractId + " , ";
    }
    if(data?.serviceMigratable){
      const serviceMigratable = data?.serviceMigratable == "כן" ? "יש" : "לא";
      description = description + "מונה חכם: " + serviceMigratable;
    }
    if(data?.state.toLowerCase() == 'session not found'){
      description = description + "לא נמצאו פרטים";
    }
  }
  else{
    description = description + "שגיאה כללית";
  }

  return description;
}

function setPageResponse(data , thunkAPI){
  if(data.state.toLowerCase() == 'completed'){
    if(data.serviceMigratable){
      thunkAPI.dispatch(serviceMessageType('FOUND'));
      gtag4({
        event: 'CounterCheck_Step3_SuccessPage',
        step: '3',
        action: 'SuccessPage',
      });
    }
    else{
      if(!data.currentConsumption){
        thunkAPI.dispatch(serviceMessageType('ERROR'));
        gtag4({
          event: 'CounterCheck_ErrorPage',
          step: '5',
          action: 'ErrorPage',
          error: 'General Error'
        });
      }
      else{
        thunkAPI.dispatch(serviceMessageType('NOT_FOUND'));
        gtag4({
          event: 'CounterCheck_Step4_NoCounterPage',
          step: '4',
          action: 'NoCounterPage',
        });
      }
    }
    thunkAPI.dispatch(goToPage('serviceMessagePage'));
  }
  else if(data.state.toLowerCase() == 'error'){
    thunkAPI.dispatch(serviceMessageType('ERROR'));
    thunkAPI.dispatch(goToPage('serviceMessagePage'));
    gtag4({
      event: 'CounterCheck_ErrorPage',
      step: '5',
      action: 'ErrorPage',
      error: 'General Error'
    });
  }
  else{
    thunkAPI.dispatch(serviceMessageType('NOT_FOUND'));
    thunkAPI.dispatch(goToPage('serviceMessagePage'));
    gtag4({
      event: 'CounterCheck_Step4_NoCounterPage',
      step: '4',
      action: 'NoCounterPage',
    });
  }

  thunkAPI.dispatch(createLead(data));
}
